import React from "react";

const FirstBiWeeklyPicker = () => {
  return (
    <>
      <option value={1}>1st</option>
      <option value={2}>2nd</option>
      <option value={3}>3rd</option>
      <option value={4}>4th</option>
      <option value={5}>5th</option>
      <option value={6}>6th</option>
      <option value={7}>7th</option>
      <option value={8}>8th</option>
      <option value={9}>9th</option>
      <option value={10}>10th</option>
      <option value={11}>11th</option>
      <option value={12}>12nd</option>
      <option value={13}>13th</option>
      <option value={14}>14th</option>
    </>
  );
};

export default FirstBiWeeklyPicker;
